export class SecurityResolutionError extends Error {
    constructor(message: string) {
        super(message);
        this.name = 'SecurityResolutionError';
    }
}

export class FeatureActionPermissionMappingError extends SecurityResolutionError {
    constructor(action: string) {
        super(`No feature permission mapping exists for action ${action}`);
        this.name = 'FeatureActionPermissionMappingError';
    }
}

export class EntityActionPermissionMappingError extends SecurityResolutionError {
    constructor(action: string) {
        super(`No entity permission mapping exists for action ${action}`);
        this.name = 'EntityActionPermissionMappingError';
    }
}

export class FeaturePermissionTokenValidationError extends SecurityResolutionError {
    constructor(tokens: string[]) {
        super(`Unknown feature permission token(s): ${tokens.join(', ')}`);
        this.name = 'FeaturePermissionTokenValidationError';
    }
}
